import {useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {AdminProductDTO} from '../../../api/data-contracts'
import AdminProductDetailsForm from '../../../components/admin/product/AdminProductDetailsForm'
import AdminProductPricesForm from '../../../components/admin/product/AdminProductPricesForm'
import {CanIDoThat} from '../../../utils/CanIDoThat'
import {UserTypeAuthorizationsEnum} from '../../../apiClient/enums'

type ActiveTab = 'details' | 'prices'

function AdminProductEditPage(props: {
  product?: AdminProductDTO | null
  isNew?: boolean
  onBack: () => void
}) {
  const [activeTab, setActiveTab] = useState<ActiveTab>('details')

  const activeFormId =
    activeTab === 'prices' ? 'admin-product-prices-form' : 'admin-product-details-form'

  return (
    <div className='card card-stretch'>
      <div className='card-header d-flex align-items-center position-relative'>
        <div
          onClick={props.onBack}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-2' />
        </div>
        <h3 className='card-title m-0 position-absolute start-50 translate-middle-x'>
          {props.isNew ? 'Yeni Ürün' : props.product?.title}
        </h3>
        {CanIDoThat(UserTypeAuthorizationsEnum.Admin_Panel_Product_Page_Edit) && (
          <button type='submit' form={activeFormId} className='btn btn-primary btn-sm ms-auto'>
            Kaydet
          </button>
        )}
      </div>
      <div className='card-body py-5'>
        <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-4 fw-bold border-0'>
          <li className='nav-item'>
            <a
              className={`nav-link ${activeTab === 'details' ? 'active' : ''}`}
              data-bs-toggle='tab'
              href='#kt_tab_pane_1'
              onClick={() => setActiveTab('details')}
            >
              Ürün Detayları
            </a>
          </li>
          {!props.isNew && (
            <li className='nav-item'>
              <a
                className={`nav-link ${activeTab === 'prices' ? 'active' : ''}`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_2'
                onClick={() => setActiveTab('prices')}
              >
                Fiyatlar
              </a>
            </li>
          )}
        </ul>

        <div className='tab-content' id='myTabContent'>
          <div
            className={`tab-pane fade mt-5 ${activeTab === 'details' ? 'show active' : ''}`}
            id='kt_tab_pane_1'
            role='tabpanel'
          >
            <AdminProductDetailsForm product={props.product} />
          </div>
          {!props.isNew && (
            <div
              className={`tab-pane fade mt-5 ${activeTab === 'prices' ? 'show active' : ''}`}
              id='kt_tab_pane_2'
              role='tabpanel'
            >
              <AdminProductPricesForm product={props.product} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AdminProductEditPage
